import * as THREE from 'three';
import { loadModel } from './Loader';
import { createOutline } from "../System/OutlineShader";
import { LODGroup, registerLODGroup } from '../System/LODManager';
import {Object3D} from "three";

export class ServerIcon {

    private lodGroup: LODGroup;

    constructor(type: string | null) {
        this.lodGroup = new LODGroup();
        const baseModelURL = ServerIcon.getModelType(type);
        this.loadModel(baseModelURL.replace('.gltf', '_high.gltf'), 1.5);
        this.loadModel(baseModelURL.replace('.gltf', '_medium.gltf'), 1.0);
        this.loadModel(baseModelURL.replace('.gltf', '_low.gltf'), 0.0);

        registerLODGroup(this.lodGroup);
    }

    private static getModelType(type: string | null): string {
        const modelPaths: Record<string, string> = {
            "directory": 'assets/three/ICONS/ANNUAIRE.gltf',
            "application": 'assets/three/ICONS/APP.gltf',
            "database": 'assets/three/ICONS/BDD.gltf',
            "configuration": 'assets/three/ICONS/CONFIG.gltf',
            "file": 'assets/three/ICONS/FICHIER.gltf',
            "print": 'assets/three/ICONS/IMP.gltf',
            "monitoring": 'assets/three/ICONS/MONITOR.gltf',
            "mail": 'assets/three/ICONS/MSG.gltf',
            "backup": 'assets/three/ICONS/SAVE.gltf',
            "web": 'assets/three/ICONS/WEB.gltf',
            "proxy": 'assets/three/ICONS/PROXY.gltf',
            "security": 'assets/three/ICONS/SECU.gltf',
        };
        return modelPaths[type || "application"];
    }

    private loadModel(url: string, threshold: number): void {
        loadModel(
            url,
            (gltf: { scene: THREE.Object3D }): void => {
                const model: Object3D = gltf.scene;
                const outline: Object3D = createOutline(model);

                // Ajustement de l'outline
                outline.position.y = -0.025;

                // Scale pour la vue 2D
                model.scale.set(1, 1, 1);
                outline.scale.set(1, 1, 1);
                model.visible = false;
                outline.visible = false;

                const container = new THREE.Group();
                container.userData.isLODContainer = true;
                model.userData.type = "Server"
                outline.userData.type = "Server"
				container.add(model, outline);

				model.traverse((object: THREE.Object3D): void => {
                    if (object instanceof THREE.Mesh) {
                        object.material = new THREE.MeshBasicMaterial({
                            map: (object.material as THREE.MeshStandardMaterial).map,
                        });
                    }
                });

                // Ajoute le container dans le LODGroup avec le seuil associé
                this.lodGroup.addLOD(container, threshold);
            },
            (progress: ProgressEvent): void => {
                // console.log(`Progression : ${(progress.loaded / progress.total) * 100}%`);
            },
            (error: unknown): void => {
                console.error('Erreur lors du chargement du modèle GLTF :', error);
            }
        );
    }

    public getGroup(): THREE.Group {
        return this.lodGroup;
    }
}
